/* eslint-disable no-unused-vars */
// noinspection ES6UnusedImports

import {isTokenSymbol} from "./utils/config.utils";

window.clientConfig.features.collageWithAnimation = isTokenSymbol(-6, "0123456789");
window.clientConfig.features.shouldShowPhotoGuideModal = isTokenSymbol(-3, "01234567");